export default __webpack_public_path__ + "static/media/google-play.3366334b.svg";